import * as React from 'react';
import { __ } from 'react-i18n/lib';
import { Button2, StyledFooter } from './ChooseModal';
import BaseModal from './BaseModal';
import API from '../../../services/API';

interface ModalProps {
  onCloseButtonClick?: (event) => void;
}

const DeliveryTimesModal = (props: ModalProps) => {
  const [body, setBody] = React.useState(null);

  React.useEffect(() => {
    API.getSettingByName('eshopDeliveryTimesModalText').then((response) => {
      if (response?.length) {
        const body: any = response.find(
          (item) => item.name === 'eshopDeliveryTimesModalText',
        )?.value;
        setBody(body);
      }
    });
  }, []);

  const { onCloseButtonClick } = props;

  return (
    <BaseModal
      title={__('Informácia o termínoch doručenia')}
      body={
        <div
          dangerouslySetInnerHTML={{
            __html: body ? body : '',
          }}
        />
      }
      footer={
        <StyledFooter>
          <Button2 className="primary lg" onClick={onCloseButtonClick}>
            {__('Zavrieť')}
          </Button2>
        </StyledFooter>
      }
      onCloseButtonClick={onCloseButtonClick}
    />
  );
};

export default DeliveryTimesModal;
